import { Card, CardContent } from '@design-system';
import { QUOTE_AGE_RANGE } from '@shared';
import { Figure, MetricGrid, metricFigureClassName } from './figures';

/** What the quote search covers, shown while it runs. */
export function QuoteSearchStats({ carrierCount }: { carrierCount: number }) {
  return (
    <Card className="bg-primary/5 border-primary/10 py-4">
      <CardContent className="px-4">
        <MetricGrid columns={4}>
          <Figure label="Quote combinations" value="1M+" className={metricFigureClassName} />
          <Figure label="Insurance carriers" value={carrierCount || '—'} className={metricFigureClassName} />
          <Figure label="Types of coverage" value="3" className={metricFigureClassName} />
          <Figure
            label="Ages quoted"
            value={`${QUOTE_AGE_RANGE.min}–${QUOTE_AGE_RANGE.max}`}
            className={metricFigureClassName}
          />
        </MetricGrid>
      </CardContent>
    </Card>
  );
}
